var ShippingObjectTypes;
(function(ShippingObjectTypes) {
    ShippingObjectTypes["BillingAddress"] = 'billingAddress';
    ShippingObjectTypes["DeliveryAddress"] = 'deliveryAddress';
    ShippingObjectTypes["ContactDetails"] = 'contactDetails';
    ShippingObjectTypes["Company"] = 'company';
    ShippingObjectTypes["Invoice"] = 'invoice';
    ShippingObjectTypes["ExpressCheckout"] = 'expressCheckout';
})(ShippingObjectTypes || (ShippingObjectTypes = {}));
var CheckoutState;
(function(CheckoutState) {
    CheckoutState["Uninitialized"] = 'uninitialized';
    CheckoutState["Initialized"] = 'initialized';
    CheckoutState["Completed"] = 'completed';
    CheckoutState["Callback"] = 'callback';
    CheckoutState["Failed"] = 'failed';
})(CheckoutState || (CheckoutState = {}));
/**
 * Checkout state guards
 */ const isState = (stateName)=>(state)=>state.root.state === stateName
;
const isUninitialized = isState(CheckoutState.Uninitialized);
const isCompleted = isState(CheckoutState.Completed);
const isFailed = isState(CheckoutState.Failed);

export { CheckoutState, ShippingObjectTypes, isCompleted, isFailed, isUninitialized };
//# sourceMappingURL=state.js.map
